var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 12.25H2.68333C2.35664 12.25 2.19329 12.25 2.06851 12.1864C1.95875 12.1305 1.86951 12.0413 1.81358 11.9315C1.75 11.8067 1.75 11.6434 1.75 11.3167V1.75M11.6667 4.66667L9.38064 7.10657C9.29402 7.19903 9.25073 7.24523 9.19847 7.26915C9.15232 7.29027 9.10152 7.29896 9.051 7.29441C8.99377 7.28922 8.93754 7.26005 8.82507 7.20166L6.92492 6.21501C6.81246 6.15662 6.75622 6.12745 6.699 6.12226C6.64848 6.11771 6.59767 6.1264 6.55153 6.14752C6.49927 6.17143 6.45598 6.21763 6.36936 6.31009L4.08333 8.75",
    stroke: "#717182",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/line_chart.54800ea0ee7bd7f9ea8342143c1ca4d4.svg";
export { ForwardRef as ReactComponent };